import * as React from "react";
import { CircleLoader } from "@/components/ui/circleLoader";
import colors from "tailwindcss/colors";

interface Props {
  progress: number;
  progressLabel: string;
}

export const DriveRowProgressbar: React.FC<Props> = ({ progress, progressLabel }) => {
  const normalizedProgressbar = progress.toFixed(0);
  return (
    <div style={{ width: 100 }} className="mr-1">
      <div className="flex items-center">
        <CircleLoader fill={colors.gray[500]} />
        <div className={"text-xs"}>
          {normalizedProgressbar}%<div className="mt-1">{progressLabel}</div>
        </div>
      </div>
    </div>
  );
};
